<template>
  <div class="page-container">
    <h1>服务器状态</h1>
    <div v-loading="loading">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="编号" width="180">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="名称" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="180">
          <template slot-scope="scope">
            <span :style="getStatusStyle(scope.row.status)">{{
              getStatus(scope.row.status)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              :disabled="!scope.row.allowRestart"
              @click="restartBtnClick(scope.row.id)"
              >重启
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- dialog -->
    <el-dialog
      title="重启提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>是否要重启服务器</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="confirmStartBtnClick()"
          >重 启</el-button
        >
      </span>
    </el-dialog>
    <!-- dialog -->
    <el-dialog
      title="重启结果"
      :visible.sync="resultDialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>{{ resultMsg }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="confirmResult()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ServerPage',
  components: {},
  data() {
    return {
      tableData: [],
      loading: true,
      dialogVisible: false,
      resultDialogVisible: false,
      resultMsg: '',
      selectServerId: 0
    }
  },
  beforeCreate() {},
  created() {
    this.queryServers()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    handleClose() {},
    getStatus(status) {
      if (status == 0) {
        return '停止中'
      } else {
        return '运行中'
      }
    },
    getStatusStyle(status) {
      if (status == 0) {
        return 'margin-left: 10px;color: #666666'
      } else {
        return 'margin-left: 10px;color: #63a35c'
      }
    },
    restartBtnClick(id) {
      this.dialogVisible = true
      this.selectServerId = id
    },
    confirmStartBtnClick() {
      this.dialogVisible = false
      this.requestStartServer()
    },
    confirmResult() {
      this.resultDialogVisible = false
      this.resultMsg = ''
      this.queryServers()
    },
    //获取视频通话数据
    queryServers() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.servers_query_servers,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableData = res.data.data
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //重启视频通话
    requestStartServer() {
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.servers_restart_server,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          serverId: this.selectServerId
        }
      }).then(
        res => {
          if (res.data.code === 0) {
            this.resultMsg = res.data.data
            this.resultDialogVisible = true
          } else if (res.data.code === 1001) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
            this.$router.push(this.$route.query.redirect || '/login')
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        },
        err => {
          this.$message({
            showClose: true,
            message: '请求错误:' + err,
            type: 'error'
          })
        }
      )
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }
}
</style>
